// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"8e474aae1c693e0c","9777":"b5869bc8f7a1d991"}[chunkId] + ".js";
};